const servicesData = [
  { id: 1, icon: "fas fa-tools", title: "RO Service & Repair", desc: "Repair services", link: "/services" },
  { id: 2, icon: "fas fa-cogs", title: "RO Installation", desc: "Installation services", link: "/services" },
  { id: 3, icon: "fas fa-industry", title: "Commercial RO", desc: "Commercial solutions", link: "/services" },
  { id: 4, icon: "fas fa-clipboard-check", title: "AMC Services", desc: "Maintenance plans", link: "/services" }
];
export default servicesData;